import { CartAddEvent, CartErrorEvent } from '@theme/events';

class QuickAddInlineComponent extends HTMLElement {
  constructor() {
    super();
    this.variantInputs = this.querySelectorAll('.quick-add__variant-input');
    this.variantIdInput = this.querySelector('input[name="id"]');
    this.loadVariantsData();
    this.bindEvents();
  }

  loadVariantsData() {
    const jsonScript = this.querySelector('.product-variants-data');
    if (jsonScript) {
      try {
        this.productData = JSON.parse(jsonScript.textContent);
      } catch (error) {
        this.productData = null;
      }
    }
  }

  bindEvents() {
    this.variantInputs.forEach(input => {
      input.addEventListener('change', this.handleVariantChange.bind(this));
    });
  }

  handleVariantChange() {
    const selectedOptions = this.getSelectedOptions();
    const totalOptions = this.querySelectorAll('.quick-add__variant-options').length;
    
    if (Object.keys(selectedOptions).length >= 2 || (Object.keys(selectedOptions).length === 1 && totalOptions === 1)) {
      const variantId = this.findMatchingVariantId();
      
      if (variantId && this.variantIdInput) {
        this.variantIdInput.value = variantId;
        this.addToCart(variantId);
      }
    }
  }

  getSelectedOptions() {
    const selectedOptions = {};
    const checkedInputs = this.querySelectorAll('.quick-add__variant-input:checked');
    
    checkedInputs.forEach(input => {
      const inputElement = input;
      selectedOptions[inputElement.name] = inputElement.value;
    });
    
    return selectedOptions;
  }

  findMatchingVariantId() {
    const selectedOptions = this.getSelectedOptions();
    
    if (!this.productData || !this.productData.variants) {
      return null;
    }
    
    for (const variant of this.productData.variants) {
      let matches = true;
      
      for (let i = 0; i < this.productData.options.length; i++) {
        const optionName = this.productData.options[i].toLowerCase();
        const variantOptionValue = variant.options[i];
        const selectedValue = selectedOptions[optionName];
        
        if (selectedValue && variantOptionValue !== selectedValue) {
          matches = false;
          break;
        }
      }
      
      if (matches && variant.available) {
        return variant.id.toString();
      }
    }
    
    return null;
  }

  async addToCart(variantId) {
    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        const cartData = await response.json();
        
        this.animateFlyToCart();
        
        document.dispatchEvent(new CartAddEvent(
          cartData,
          this.dataset.productId,
          {
            variantId: variantId,
            itemCount: cartData.item_count,
            source: 'quick-add-inline'
          }
        ));
      } else {
        const errorData = await response.json();
        document.dispatchEvent(new CartErrorEvent(
          this.dataset.productId,
          errorData.message,
          errorData.description,
          errorData
        ));
      }
    } catch (error) {
      document.dispatchEvent(new CartErrorEvent(
        this.dataset.productId,
        'Network error',
        'Failed to add product to cart',
        { error: error.message }
      ));
    }
  }

  animateFlyToCart() {
    const cartIcon = document.querySelector('.header-actions__cart-icon');
    const productImage = this.getProductImage();
    
    if (!cartIcon || !productImage) return;

    const flyToCartElement = document.createElement('fly-to-cart');
    flyToCartElement.style.setProperty('background-image', `url(${productImage})`);
    flyToCartElement.source = this;
    flyToCartElement.destination = cartIcon;

    document.body.appendChild(flyToCartElement);
  }

  getProductImage() {
    const productCard = this.closest('[data-featured-media-url]');
    if (productCard?.dataset.featuredMediaUrl) {
      return productCard.dataset.featuredMediaUrl;
    }
    
    const productImage = this.closest('.product-card')?.querySelector('img');
    return productImage?.src || null;
  }
}

customElements.define('quick-add-inline-component', QuickAddInlineComponent);
